<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">雲端編輯器</h1>
                        <h2>隨時隨地輕鬆寫作，就用 Trinka Cloud</h2>
                        <p>使用您慣用的瀏覽器安全存取並編輯文件，隨時隨地寫得更好。</p>
                        <div class="btn-group">
                            <a id="TrinkaCloudGetStarted" class="filled-btn" href="https://cloud.trinka.ai/signup?_TW" target="_blank">開始使用</a>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/trinka-cloud/cloud_banner_img.webp" width="518" height="443" alt="cloud banner" class="img-fluid" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-how-it-works section-pd-sm bg-light-purple">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="trinka-title text-center">
                    <h2>使用方式</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <ul>
                    <li>
                        <div class="login_circle_section">
                            <img src="/assets/images/RegisterAndLogin.png" width="48" height="46" alt="register" />
                        </div>
                        <h3>註冊／登入</h3>
                    </li>
                    <li>
                        <div class="arrow">
                            <img src="/assets/images/person-arrow.png" width="140" height="102" alt=" arrow" class="img-fluid" />
                        </div>
                    </li>
                    <li>
                        <div class="login_circle_section">
                            <img src="/assets/images/TypeOrImportFile_icon.png"  width="36" height="45" alt="import" />
                        </div>
                        <h3>輸入或匯入文件</h3>
                    </li>
                    <li>
                        <div class="arrow">
                            <img src="/assets/images/person-arrow.png"  width="140" height="102" alt="arrow" class="img-fluid" />
                        </div>
                    </li>
                    <li>
                        <div class="login_circle_section">
                            <img src="/assets/images/improveYourWriting_icon.png"  width="40" height="48" alt="writing" />
                        </div>
                        <h3>提升寫作品質</h3>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka Cloud 主要特色</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p class="w-100">Trinka Cloud 讓您隨時隨地自由寫作，透過即時的高級英文文法修正，Trinka 始終與您同行。功能強大的線上編輯器不僅自動儲存內容，還支援文件匯入與匯出。有效寫作，從未如此輕鬆直覺。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="/assets/images/grammar-checker-icon.svg" width="40" height="40" alt="Grammar Checker" />
                    <h3>英文文法檢查器</h3>
                    <p>即時提供高級寫作建議與文法修正，無論您在哪裡寫作，Trinka 都隨時待命。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="/assets/images/multilingual-icon.png" width="40" height="40" alt="Grammar Checker" />
                    <h3>多語系文法檢查</h3>
                    <p>精準提升您的西班牙文寫作。Trinka 自動辨識語言，並提出優化建議。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="/assets/images/autoFileEdit_icon.svg" width="40" height="40" alt="auto file">
                    <h3>文件校對</h3>
                    <p>上傳您的 Word 文件，Trinka 將自動完成校對。幾分鐘內搞定，下載即可使用。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 dflex">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/paraphraser-icon.svg" width="40" height="40" alt="Paraphraser">
                    <h3>AI 文章改寫工具 <div class="beta-badge">全新推出</div></h3>
                    <p>在你寫作的同時，AI 會理解你的表達意圖，主動提供重寫建議，幫助你使內容更清晰、連貫且符合文法規範。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/ppc_icon.png" width="40" height="40" alt="ppc">
                    <h3>抄襲檢查</h3>
                    <p>運用領先業界的文字相似度演算法，對照全球最大付費出版資料庫，涵蓋所有學科領域。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/PublicationReadiness.svg" width="40" height="40" alt="publication readiness">
                    <h3>技術合規檢查</h3>
                    <p>針對 20 多個出版成功關鍵項目進行全面分析，從期刊選擇到倫理合規，全面掌握。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/ConsistencyCheck_icons.png" width="40" height="40" alt="consistency check">
                    <h3>一致性檢查</h3>
                    <p>找出難以察覺的不一致用法，特別適用於篇幅較長的文件。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/reference-quality.png" width="40" height="40" alt="reference quality">
                    <h3>引文檢查</h3>
                    <p>辨識削弱論點的引文，協助您改用可信、有力的來源，讓研究論述更具說服力。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/journalFinder.svg" width="40" height="40" alt="journal-finder">
                    <h3>期刊查找工具</h3>
                    <p>比對您的研究內容與數百萬筆出版資料與趨勢，找出最適合投稿的期刊。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/style_guide_icon.svg" width="40" height="40" alt="style guide">
                    <h3>學術寫作風格設定</h3>
                    <p>自訂文法與用字偏好，輕鬆符合主流學術寫作格式（如 AMA 第11版、AGU 2017）。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <img src="/assets/images/AddtoDictionary.svg" width="40" height="40" alt="add to dictionary">
                    <h3>新增至個人詞典</h3>
                    <p>將專屬詞彙加入「我的詞典」，Trinka 將自動略過這些詞的拼字檢查，讓您的專業用語保持一致。</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="ListLiners hideFirstList">
    <app-import-files></app-import-files>
</section>

<section class="ListLiners hideTrinkaCloud">
    <app-trinka-in-other-apps></app-trinka-in-other-apps>
</section>